import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import uuid from 'uuid';
import classnames from 'classnames';

const UniqueKeyV4 = ({ name = 'uniqueKeyV4', defaultValue = uuid.v4(), show = false }) => {
  const methods = useFormContext();

  return (
    <Controller
      control={methods.control}
      name={name}
      defaultValue={defaultValue}
      render={({ field:{ value } }) => (
        <p
          className={classnames({
            'd-none': !show,
            'd-block': show,
          })}
        >
          {value}
        </p>
      )}
    />
  );
};

export default UniqueKeyV4;
